import { render } from "./ContestPrizes.vue?vue&type=template&id=62d25d7d&scoped=true"
import script from "./ContestPrizes.vue?vue&type=script&lang=js"
export * from "./ContestPrizes.vue?vue&type=script&lang=js"

import "./ContestPrizes.vue?vue&type=style&index=0&id=62d25d7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d25d7d"]])

export default __exports__